"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_ACTION_NAME = exports.USER_ACTION_LOCATION = void 0;
const USER_ACTION_NAME = exports.USER_ACTION_NAME = 'language_select';
const USER_ACTION_LOCATION = exports.USER_ACTION_LOCATION = 'popup';